<script setup lang="ts">
definePageMeta({
  name: 'inspections-expo-exchange-slug-index',
  layout: 'default',
  hideDefaultTopNav: true,
})

const currentPage = 1
</script>

<template>
  <HeaderWikiBitPcTopNav :always-expand-search="true" :force-solid-background="true" />
  <SurveyInspectionExpoListContent :current-page="currentPage" />
</template>
